import { WEEK_DAYS } from 'core/const';
import { WeekDay } from 'core/type';

export class DaysHelper {
  public static getWeekDays(firstDayOfWeek = 1): WeekDay[] {
    const firstDay = firstDayOfWeek % 7;

    return WEEK_DAYS.slice(firstDay).concat(WEEK_DAYS.slice(0, firstDay));
  }
}
